import { useLang } from "@/lib/i18n";

export default function Artifacts({ items, note }) {
  const { t } = useLang();
  if (!items?.length) return null;
  return (
    <section
      data-testid="case-study-artifacts"
      className="py-10 lg:py-14 border-t border-[#e5e0d8]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="max-w-2xl">
          <div className="font-mono-label text-[11px] text-[#9a7218]">
            {t("Research artefacts")}
          </div>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl leading-tight text-[#14352a]">
            The instruments behind the findings.
          </h2>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {items.map((a, i) => (
            <figure
              key={i}
              data-testid={`artifact-${i}`}
              className={`${a.wide ? "md:col-span-2" : ""} bg-white border border-[#e5e0d8]`}
            >
              <a
                href={a.src}
                target="_blank"
                rel="noreferrer"
                className="block bg-[#f2ece4] border-b border-[#e5e0d8] overflow-hidden"
              >
                <img
                  src={a.src}
                  alt={a.title}
                  loading="lazy"
                  className="w-full h-auto max-h-[560px] object-contain"
                />
              </a>
              <figcaption className="p-6">
                <div className="font-display text-xl text-[#14352a]">
                  {a.title}
                </div>
                <p className="mt-2 text-sm text-[#55625b] leading-relaxed">
                  {a.caption}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>

        {note && (
          <p
            data-testid="artifacts-note"
            className="mt-6 font-mono-label text-[10px] text-[#86928a] max-w-3xl leading-relaxed"
          >
            {note}
          </p>
        )}
      </div>
    </section>
  );
}
